<template>
  <div class="profile-section">
    <b-card class="profile-card">
      <b-alert
          v-if="personalInfoUpdated"
          show
          dismissible
          variant="success">Personal Info updated successfully.</b-alert>
      <b-card-body>
        <b-alert v-if="userProfileUpdated" show dismissible variant="success">Profile Photo Updated.</b-alert>
        <b-card-title class="dark-variant">
          Profile
          <button v-b-modal.personal-info>
            <b-icon icon="brush"></b-icon>
            <span>Edit</span>
          </button>
        </b-card-title>
        <div class="profile">
          <div class="profile-image">
            <div class="profile-preview" id="profile-view">
              <!-- <input type="file" name="profile-image" id="profile-image" ref="userFile" accept="image/png, image/jpeg" @change="onUserImageChange"> -->
              <!-- <img :src="userImage" alt="profile preview" class="image-preview"/> -->
              <input
                type="file"
                name="profile-image"
                id="profile-image"
                ref="userFile"
                accept="image/png, image/jpeg"
                @change="onUserImageChange"
              />
              <img :src="userImage" alt="profile preview" class="image-preview" />
            </div>
            <div class="label">
              <label for="profile-image" id="label">Click to Change</label>
            </div>
          </div>
          <div class="personal-description">
            <p class="name">
              {{ profile.author.full_name }}
              <span class="icon">
                <b-icon icon="check"></b-icon>
              </span>
            </p>
            <span v-if="profile.merchant" class="account-type">Merchant Account</span>
            <span v-else class="account-type">Personal Account</span>
          </div>
          <b-modal id="personal-info" size="md" title="Edit Personal Info" v-bind:hide-footer="true">
            <b-form @submit.stop.prevent="submitPersonalInfo">
              <label for="first-question">Enter Your Name</label>
              
              <b-form-input v-model.trim="f_name" :class="errors.f_name ? 'errors' : ''" placeholder="Enter first name"></b-form-input>
              <span class="text-danger float-right" v-if="errors.f_name">{{ errors.f_name}}</span>

              <b-form-input v-model.trim="m_name" :class="errors.m_name ? 'errors' : ''" placeholder="Enter middle name"></b-form-input>
              <span class="text-danger float-right" v-if="errors.m_name">{{ errors.m_name}}</span>

              <b-form-input v-model.trim="l_name" :class="errors.l_name ? 'errors' : ''" placeholder="Enter last name"></b-form-input>
              <span class="text-danger float-right" v-if="errors.l_name">{{ errors.l_name}}</span>

              <hr />
              <div class="text-right">
                <b-button
                  variant="secondary"
                  @click="$bvModal.hide('personal-info')"
                  class="mr-1"
                >Cancel</b-button>
                <b-button variant="primary" type="submmit" class="ml-1">OK</b-button>
              </div>
            </b-form>

          </b-modal>
        </div>
      </b-card-body>
    </b-card>
    <b-card class="profile-card" no-body>
      <b-card-body>
        <b-alert
          v-if="basicInfoUpdated"
          show
          dismissible
          variant="success"
        >Basic Info updated successfully.</b-alert>
        <b-card-title class="dark-variant">
          Basic Information
          <button v-b-modal.basic-information class="edit-basic-information">
            <b-icon icon="brush"></b-icon>
            <span>Edit</span>
          </button>
        </b-card-title>
        <div class="basic-info">
          <div class="birth-date">
            <label for="birth-date" class="dark-variant">Birth Date *</label>
            <span>{{ showValue(profile.author.date_of_birth) }}</span>
          </div>
          <div class="gender">
            <label for="country" class="dark-variant">Country *</label>
            <span>{{ showValue(profile.author.country) }}</span>
          </div>
          <b-modal
            id="basic-information"
            ref="basic-information"
            size="md"
            title="Edit Basic Information"
            v-bind:hide-footer="true"
            @show="prefillBasicForm"
          >
            <b-form @submit.stop.prevent="submitBaicForm">
              <b-toast
                id="error-toast"
                variant="danger"
                solid
                append-toast
                toaster="b-toaster-top-center"
              >
                <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline">
                  <strong class="mr-auto">
                    <div v-if="message">
                      <p v-if="message.length>0">{{message}}</p>
                    </div>
                  </strong>
                </div>
              </b-toast>
              <label for="birth-date" class="dark-variant">Birth Date *</label>
              <b-form-input
                id="example-input"
                v-model="date"
                type="date"
                placeholder="YYYY-MM-DD"
                autocomplete="off"
                :max="currentDate"
                :class="errors.date ? 'errors' : ''"
              ></b-form-input>
              <span class="text-danger float-right" v-if="errors.date">{{ errors.date}}</span>

              <!-- Country is a dropdown: the API stores the country NAME, and free text
                   is how values like "Nepals" ended up on the profile. -->
              <label for="country" class="dark-variant">Your Country *</label>
              <b-form-select
                v-model="country"
                :options="countries"
                value-field="name"
                text-field="name"
                :class="errors.country ? 'errors' : ''"
              >
                <template v-slot:first>
                  <b-form-select-option :value="null" disabled>-- Select a country --</b-form-select-option>
                </template>
              </b-form-select>
              <span class="text-danger float-right" v-if="errors.country">{{ errors.country }}</span>
              <hr />
              <div class="text-right">
                <b-button
                  variant="secondary"
                  @click="$bvModal.hide('basic-information')"
                  class="mr-1"
                >Cancel</b-button>
                <b-button variant="primary" type="submmit" class="ml-1">OK</b-button>
              </div>
            </b-form>
          </b-modal>
        </div>
      </b-card-body>
    </b-card>
    <!-- Address Information section removed - the address is captured in KYC. -->
    <b-card class="profile-card" no-body>
      <b-card-body>
        <b-alert
          v-if="currencyInfoUpdated"
          show
          dismissible
          variant="success"
        >Currency Info updated successfully.</b-alert>
        <b-card-title class="dark-variant">
          Currency
          <button v-b-modal.currency-info class="edit-currency">
            <b-icon icon="brush"></b-icon>
            <span>Edit</span>
          </button>
        </b-card-title>
        <div class="currency-info">
          <!-- <div class="time-zone">
            <label class="dark-variant">Timezone *</label>
            <span>{{ profile.author.timezone ? timezones.find(x => x.id === profile.author.timezone.id).timezone_name : '' }}</span>
          </div> -->
          <div class="currency">
            <label for="currency" class="dark-variant">Currency *</label>
            <span>
              <!-- {{ currencies.rates.find(x.currency_code === profile.author.default_currency).currency_name }} -->
              {{ profile.author.default_currency }} ({{ currencies.rates.find(x => x.currency_code === profile.author.default_currency)?.symbol }})
            </span>
            <!-- <span>{{ profile.author.default_currency ? currencies.rates.find(x => x.id === profile.author.default_currency.id).ISO_code : '' }}</span> -->
          </div>
          <div class="time-zone">
            <label class="dark-variant">Rate to US ($) *</label>
            <span>{{ currencies.rates.find(x => x.currency_code === profile.author.default_currency)?.rate || 'N/A' }}</span>
          </div>
          <b-modal
            id="currency-info"
            size="md"
            title="Edit Currency Info"
            v-bind:hide-footer="true"
            @show="prefillCurrencyForm"
          >
            <b-form @submit.stop.prevent="submitCurrencyData">
              <!-- <label for="timepicker-buttons">Time Zone</label>
              <b-form-select
                v-model="time"
                type="text"
                :options="timezones"
                value-field="id"
                text-field="timezone_name"
                :class="errors.time ? 'errors' : ''"
              >
                <template v-slot:first>
                  <b-form-select-option :value="null" disabled>-- Select a timezone --</b-form-select-option>
                </template>
              </b-form-select>
              <span class="text-danger float-right" v-if="errors.time">{{ errors.time}}</span> -->

              <label for="currency" class="dark-variant">Currency *</label>
              <b-form-select
                v-model="currencyType"
                :options="currencies.rates"
                value-field="currency_code"
                text-field="currency_name"
                :class="errors.currencyType ? 'errors' : ''"
              >
                <template v-slot:first>
                  <b-form-select-option :value="null" disabled>-- Select currency --</b-form-select-option>
                </template>
              </b-form-select>
              <span
                class="text-danger float-right"
                v-if="errors.currencyType"
              >{{ errors.currencyType}}</span>
              <hr />
              <div class="text-right">
                <b-button
                  variant="secondary"
                  @click="$bvModal.hide('currency-info')"
                  class="mr-1"
                >Cancel</b-button>
                <b-button variant="primary" type="submmit" class="ml-1">OK</b-button>
              </div>
            </b-form>
          </b-modal>
        </div>
      </b-card-body>
    </b-card>

    <!-- Documents section removed - KYC owns document upload and review. -->
    <!-- <div class="update-button">
      <b-button class="update-profile">Update profile</b-button>
    </div> -->
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import genderList from "../../json/gender.json";
import currencyList from "../../json/currency.json";
import timeZoneList from "../../json/timezone.json";
export default {
  name: "ProfileSection",

  computed: {
    ...mapState([
      "profile",
      "kycdata",
      "countries",
      "successmessage",
      "errormessage",
      "message",
      "timezones",
      "currencies",
    ]),
    /** "-" instead of a blank or the string "null" the API sometimes returns. */
    showValue() {
      return function (value) {
        if (value === null || value === undefined) { return '-'; }
        const text = String(value).trim();
        return (text === '' || text.toLowerCase() === 'null') ? '-' : text;
      };
    }
  },
  created() {
    this.listProfile();
    this.listUserKyc();
    this.listCountries();
    this.listTimezones();
    this.listCurrencies();
  },
  data() {
    return {
      documentType: null,
      state: "",
      country: null,
      genderType: null,
      optionsforGender: genderList,
      currencyType: null,
      optionsforCurrency: currencyList,
      image: "http://via.placeholder.com/450?text=User%20Image",
      type: [
        "text",
        "number",
        "email",
        "password",
        "search",
        "url",
        "tel",
        "date",
        "time",
        "range",
        "color",
      ],
      date: "",
      time: null,
      optionsforTimeZone: timeZoneList,
      issueDate: "",
      f_name: "",
      m_name: "",
      l_name: "",
      city: "",
      street: "",
      zipcode: "",
      addressline1: "",
      addressline2: "",
      userImage: "http://via.placeholder.com/450?text=User%20Image",
      userImgFile: {
        file: "",
        fileSize: "",
        fileType: "",
        fileMaxSize: 1048576,
        fileSupportedType: ["image/png", "image/jpeg", "image/jpg"],
      },
      documentImage: "",
      documentFile: {
        file: "",
        fileSize: "",
        fileType: "",
        fileMaxSize: 1048576,
        fileSupportedType: ["image/png", "image/jpeg", "image/jpg"],
      },
      currentDate: new Date().toISOString().substring(0,10),
      verifySecondaryEmail: false,
      userProfileUpdated: false,
      personalInfoUpdated: false,
      basicInfoUpdated: false,
      addressInfoUpdated: false,
      currencyInfoUpdated: false,
      documentUploaded: false,
      success_message: '',
      single_document: [],
      errors: [],
    };
  },
  methods: {
    ...mapActions([
      "listProfile",
      "listUserKyc",
      "listCountries",
      "listTimezones",
      "listCurrencies",
    ]),
    onUserImageChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      this.createUserImage(files[0]);
      this.userImgFile.file = this.$refs.userFile.files[0];
      this.userImgFile.fileSize = this.userImgFile.file.size;
      this.userImgFile.fileType = this.userImgFile.file.type;

      this.onProfileImageChange();
    },
    filechange(e) {
      const file = e.target.files[0];
      this.image = URL.createObjectURL(file);
    },
    createUserImage(userFile) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.userImage = e.target.result;
      };
      reader.readAsDataURL(userFile);
    },
    onDocumentImageChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      this.createFormImage(files[0]);
      this.documentFile.file = this.$refs.docFile.files[0];
      this.documentFile.fileSize = this.documentFile.file.size;
      this.documentFile.fileType = this.documentFile.file.type;
    },
    createFormImage(docFile) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.documentImage = e.target.result;
      };
      reader.readAsDataURL(docFile);
    },
    onProfileImageChange() {
      let formData = new FormData();
      formData.append("first_name", this.profile.author.first_name);
      formData.append("middle_name", this.profile.author.middle_name);
      formData.append("last_name", this.profile.author.last_name);
      formData.append("image", this.userImgFile.file);
      formData.append(
        "secondary_email",
        this.profile.author.secondary_email && this.profile.author.secondary_email != "null"
          ? this.profile.author.secondary_email
          : ""
      );
      formData.append("DOB", this.profile.author.DOB && this.profile.author.DOB != "null" ? this.profile.author.DOB : "");
      formData.append("gender", this.profile.author.gender && this.profile.author.gender != "null" ? this.profile.author.gender : "");
      formData.append(
        "timezone",
        this.profile.author.timezone && this.profile.author.timezone != "null" ? this.profile.author.timezone.id : ""
      );
      formData.append(
        "currency",
        this.profile.author.currency ? this.profile.author.currency.id : ""
      );
      formData.append("address1", this.profile.author.address1 && this.profile.author.address1 != "null" ? this.profile.author.address1 :  "");
      formData.append("address2", this.profile.author.address2 && this.profile.author.address2 != "null" ? this.profile.author.address2 : "");

      // for (var pair of formData.entries()) {
      //   console.log(pair[0] + ", " + pair[1]);
      // }

      this.$store.dispatch("updateProfile", formData).then(() => {
        if (this.successmessage == "success") {
          this.userProfileUpdated = true;
          setTimeout(function () {
            location.reload();
          }, 1500);
        } else if (this.errormessage == "errormessage") {
          //
        }
      });
    },
    submitPersonalInfo(e){
      e.preventDefault();
      this.errors = [];
      
      if (this.f_name == "") {
        this.errors["f_name"] = "First name required";
      } else if(this.l_name == "") {
        this.errors["l_name"] = "Last name required";
      } else {
        this.$bvModal.hide("personal-info");
        let formData = new FormData();
        formData.append("first_name", this.f_name);
        formData.append("middle_name", this.m_name);
        formData.append("last_name", this.l_name);
        formData.append("image", "");
        formData.append(
          "secondary_email",
          this.profile.author.secondary_email && this.profile.author.secondary_email != "null"
            ? this.profile.author.secondary_email
            : ""
        );
        formData.append("DOB", this.profile.author.DOB && this.profile.author.DOB != "null" ? this.profile.author.DOB : "");
      formData.append("gender", this.profile.author.gender && this.profile.author.gender != "null" ? this.profile.author.gender : "");
        formData.append(
          "timezone",
          this.profile.author.timezone ? this.profile.author.timezone.id : ""
        );
        formData.append(
          "currency",
          this.profile.author.currency ? this.profile.author.currency.id : ""
        );
        formData.append("address1", this.profile.author.address1);
        formData.append("address2", this.profile.author.address2);

        this.$store.dispatch("updateProfile", formData).then(() => {
          if (this.successmessage == "success") {
            this.personalInfoUpdated = true;
            setTimeout(function () {
              location.reload();
            }, 1500);
          } else if (this.errormessage == "errormessage") {
            //
          }
        });
      }
    },
    /**
     * Every field PUT /v1/profile/update accepts, per the API schema:
     *   first_name, middle_name, last_name, image, default_currency, country, date_of_birth
     *
     * PUT replaces the resource, so each call sends the CURRENT value of everything it is
     * not changing. The previous version sent only the two fields being edited, which is
     * what a PATCH would want - on a PUT the omitted fields are at the server's mercy.
     *
     * `image` is deliberately left out: it is uploaded separately as a file, and sending
     * it back as a string here would either clear the avatar or corrupt the stored path.
     */
    buildProfilePayload(overrides) {
      const a = (this.profile && this.profile.author) || {};
      const clean = function (v) {
        return (v === null || v === undefined || v === 'null') ? '' : String(v);
      };
      const payload = {
        first_name: clean(a.first_name),
        middle_name: clean(a.middle_name),
        last_name: clean(a.last_name),
        default_currency: clean(a.default_currency),
        country: clean(a.country),
        date_of_birth: clean(a.date_of_birth)
      };
      return Object.assign(payload, overrides || {});
    },

    /** Load the current values into the Basic Information modal before it opens. */
    prefillBasicForm() {
      const a = (this.profile && this.profile.author) || {};
      this.errors = [];
      this.date = a.date_of_birth || '';
      this.country = a.country || null;
    },

    submitBaicForm(e) {
      e.preventDefault();
      this.errors = [];
      if (!this.date) {
        this.errors["date"] = "DOB required";
      } else if (this.date >= this.currentDate) {
        this.errors["date"] = "DOB Must less than Today.";
      } else if (!this.country) {
        this.errors["country"] = "Country required";
      } else {
        this.$bvModal.hide("basic-information");
        const payload = this.buildProfilePayload({
          country: this.country,
          date_of_birth: this.date
        });
        this.$store.dispatch("updateProfile", payload).then(() => {
          if (this.successmessage == "success") {
            this.basicInfoUpdated = true;
            setTimeout(function () {
              location.reload();
            }, 1500);
          } else if (this.errormessage == "errormessage") {
            this.$bvToast.show("error-toast");
          }
        });
      }
    },
    prefillCurrencyForm() {
      const a = (this.profile && this.profile.author) || {};
      this.errors = [];
      this.currencyType = a.default_currency || null;
    },

    /**
     * Sets the account's DEFAULT CURRENCY.
     *
     * The old version posted secondary_email, DOB, gender, timezone, currency, address1 and
     * address2 - none of which exist in the profile/update schema, and two of which
     * (DOB, gender) are not even fields on the profile object, so they went up as
     * "undefined". The single key this endpoint recognises is `default_currency`.
     */
    submitCurrencyData(e) {
      e.preventDefault();
      this.errors = [];

      if (!this.currencyType) {
        this.errors["currencyType"] = "Currency required";
      } else {
        this.$bvModal.hide("currency-info");
        const payload = this.buildProfilePayload({
          default_currency: this.currencyType
        });
        this.$store.dispatch("updateProfile", payload).then(() => {
          if (this.successmessage == "success") {
            this.currencyInfoUpdated = true;
            setTimeout(function () {
              location.reload();
            }, 1500);
          } else if (this.errormessage == "errormessage") {
            this.$bvToast.show("error-toast");
          }
        });
      }
    },
  },
  mounted() {
    //console.log("P: ",this.profile)
    this.userImage = this.profile.author.image;
    this.f_name = this.profile.author.first_name;
    this.m_name = this.profile.author.middle_name;
    this.l_name = this.profile.author.last_name;
    this.date = this.profile.author.date_of_birth;
    this.genderType = this.profile.author.gender;
    this.time = this.profile.author.timezone;
    this.currencyType = this.profile.author.currency;
    this.verifySecondaryEmail = this.profile.author.verify_secondary_email;
    if (this.profile.author) {
      this.city = this.profile.author.useraddress[0].city;
      this.state = this.profile.author.useraddress[0].state;
      this.country = this.profile.author.country;
      this.zipcode = this.profile.author.useraddress[0].zip_code;
      this.addressline1 = this.profile.author.address1;
      this.addressline2 = this.profile.author.address2;
    }
  },
};
</script>
<style lang="scss">
  @import '../../css/style.scss';
.documentImage {
  max-width: 100%;
  max-height: 100%;
}
</style>
